export const iconFontAwesomeTransportationTrain = (
	<i className="fa-solid fa-train"></i>
);
